import * as React from "react"
import { Box, Typography } from "@mui/material"


export default function activeUsersColumn() {
	return {
		name: 'activeUsers',
		label: "Active Users",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { totalUsers }) => <Box textAlign="center" p={.5}>
				{value}
				<Typography color="text.disabled" display="inline" fontSize="0.75rem">
					/{totalUsers}
				</Typography>
			</Box>
		}
	}
}